import React from 'react';
import Input from './../../input';
import Range from './../../range_input';
import Color from './../../color_input';

import createReactClass from 'create-react-class';
export default createReactClass({
  displayName: 'BackgroundControls',

  render: function() {
    return (
      <div className="customization-controls">
        <Input
          label="Background image"
          name="background_image"
          type="text"
          defaultValue={this.props.background_image}
          onChange={this.props.onChange.bind(null, 'background_image')}
        />
        <Color
          label="Primary text color"
          name="primary_text_color"
          defaultValue={this.props.primary_text_color}
          onChange={this.props.onChange.bind(null, 'primary_text_color')}
        />
        <Color
          label="Secondary text color"
          name="secondary_text_color"
          defaultValue={this.props.secondary_text_color}
          onChange={this.props.onChange.bind(null, 'secondary_text_color')}
        />
        <Color
          label="Button color"
          name="button_color"
          defaultValue={this.props.button_color}
          onChange={this.props.onChange.bind(null, 'button_color')}
        />
        <Color
          label="Button text color"
          name="button_text_color"
          defaultValue={this.props.button_text_color}
          onChange={this.props.onChange.bind(null, 'button_text_color')}
        />
        <Color
          label="Shadow color"
          name="shadow_color"
          defaultValue={this.props.shadow_color}
          onChange={this.props.onChange.bind(null, 'shadow_color')}
        />
        <Range
          label="Shadow distance"
          min="1"
          max="75"
          defaultValue={this.props.shadow_distance}
          onChange={this.props.onChange.bind(null, 'shadow_distance')}
        />
      </div>
    );
  },
});
